import React from 'react';
import { ResponsiveBar } from '@nivo/bar';
import 'whatwg-fetch';
import { deleteEntity } from 'src/utils/entityApi';
import ModalConfirm from '../../components/modal/modalConfirm';
import { buildRequestStatistic } from 'src/utils/dashboardTools';
import Card from 'src/components/Card';
import { Link, Typography } from '@material-ui/core';
import withAuth from 'src/hoc/withAuth';

class DashletBarChart extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      data: undefined,
      dashletInfo: undefined,
      dashletParsed: false,
      isModalDeleteDashletOpen: false,
      textModal: {
        title: 'Suppression Dashlet',
        message: 'Vous allez supprimer le dashlet',
      },
    };

    this.openModalDeleteDashlet = this.openModalDeleteDashlet.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.update = this.update.bind(this);
  }

  refreshData(request) {
    this.props
      .authFetch(request, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        method: 'GET',
      })
      .then((resp) => resp.json())
      .then(
        function (data) {
          const dashletData = data['data'][this.state.dashletInfo.metadata.statisticSelected.graphQlQuery];

          this.setState({
            data: (dashletData || []).map((d) => ({
              ...d,
              value: parseFloat(d.value),
            })),
          });
        }.bind(this)
      )
      .catch(
        function (error) {
          console.log('erreur fetch data: \n' + error);
        }.bind(this)
      );
  }

  componentDidMount() {
    let dashlet = this.props.dashletInfo;

    if (dashlet && !this.state.dashletParsed) {
      if (typeof dashlet.metadata === 'string')
        //Necessary when you switch dashboard and return
        dashlet.metadata = JSON.parse(dashlet.metadata);
      this.setState({
        dashletInfo: dashlet,
        dashletParsed: true,
      });
    }
    this.refreshData(buildRequestStatistic(dashlet));
  }

  openModalDeleteDashlet() {
    this.props.toggleBlackOut();
    this.setState({
      isModalDeleteDashletOpen: true,
    });
  }
  closeModal() {
    this.setState({
      isModalDeleteDashletOpen: false,
    });
    this.props.toggleBlackOut();
  }

  postResult(type, promise) {
    promise.then(
      function (result) {
        if (result.wentFine) {
          this.props.openToast(true, 'Succès supression ' + type);
          this.props.onDelete();
        } else {
          this.props.openToast(false, 'Erreur suppression ' + type + '. Veuillez réessayer');
        }
      }.bind(this)
    );
  }

  update() {
    this.props.onUpdate(this.state.dashletInfo);
  }

  render() {
    return (
      <Card style={{ display: 'block' }} className='dashlet'>
        <Typography variant='h6'>{this.state.dashletInfo ? this.state.dashletInfo.title : 'Chargement'}</Typography>
        <Link component='button' onClick={() => this.refreshData(buildRequestStatistic(this.state.dashletInfo))}>
          Rafraîchir
        </Link>
        {` - `}
        <Link component='button' onClick={this.update}>
          Editer
        </Link>

        {this.state.dashletInfo && (
          <button
            onClick={this.openModalDeleteDashlet}
            type='button'
            className='close dashlet-close'
            aria-label='Close'
          >
            <span aria-hidden='true'>&times;</span>
          </button>
        )}
        <div className='dashlet-content'>
          {this.state.data && (
            <ResponsiveBar
              data={this.state.data}
              keys={['value']}
              indexBy='label'
              margin={{ top: 50, right: 130, bottom: 50, left: 60 }}
              padding={0.3}
              colors={{ scheme: 'nivo' }}
              borderColor='inherit:darker(1.6)'
              borderRadius={5}
              layout={this.state.dashletInfo.type === 'dashlet-horizontal-bar' ? 'horizontal' : 'vertical'}
              axisTop={null}
              axisRight={null}
              theme={{
                grid: {
                  line: {
                    stroke: '#f3f3f3',
                    strokeWidth: 1,
                  },
                },
              }}
              axisBottom={{
                tickSize: 0,
                tickPadding: 5,
                tickRotation: -30,
                legend:
                  this.state.dashletInfo.type === 'dashlet-horizontal-bar'
                    ? this.state.dashletInfo.metadata.statisticSelected.axisLeft
                    : this.state.dashletInfo.metadata.statisticSelected.axisBottom,
                legendPosition: 'middle',
                legendOffset: 32,
              }}
              axisLeft={{
                tickSize: 0,
                tickPadding: 5,
                tickRotation: 0,
                legend:
                  this.state.dashletInfo.type === 'dashlet-horizontal-bar'
                    ? this.state.dashletInfo.metadata.statisticSelected.axisBottom
                    : this.state.dashletInfo.metadata.statisticSelected.axisLeft,
                legendPosition: 'middle',
                legendOffset: -40,
              }}
              labelSkipWidth={12}
              labelSkipHeight={12}
              labelTextColor='inherit:darker(1.6)'
              legends={[
                {
                  dataFrom: 'keys',
                  anchor: 'bottom-right',
                  direction: 'column',
                  justify: false,
                  translateX: 120,
                  translateY: 0,
                  itemsSpacing: 2,
                  itemWidth: 100,
                  itemHeight: 20,
                  itemDirection: 'left-to-right',
                  itemOpacity: 0.85,
                  symbolSize: 20,
                  effects: [
                    {
                      on: 'hover',
                      style: {
                        itemOpacity: 1,
                      },
                    },
                  ],
                },
              ]}
              animate={true}
              motionStiffness={90}
              motionDamping={15}
            />
          )}
        </div>
        <ModalConfirm
          className='myModal'
          modalText={this.state.textModal}
          isOpen={this.state.isModalDeleteDashletOpen}
          onSubmit={() =>
            this.postResult('dashlet', deleteEntity(this.props.authFetch, 'dashlet', this.state.dashletInfo.id))
          }
          onCancel={this.closeModal}
          onClose={this.closeModal}
        />
      </Card>
    );
  }
}

export default withAuth(DashletBarChart);
